import { isValidArray, tr } from 'mmfintech-commons'

import { Spinner } from 'mmfintech-portal-commons'
import { BackIcon } from '@icons'
import { SelectBankItem } from './SelectBankItem'

import type { SupportedBank, UseFilteredBanksOutput } from 'mmfintech-checkout-commons/types'

import './selectBank.scss'

type SelectBankProps = {
  banks?: UseFilteredBanksOutput
  selected?: string
  loading?: boolean
  handleSubmit?: () => void
}

const SelectBank = ({ banks, selected, loading, handleSubmit }: SelectBankProps) => {
  const handleClick = (bank: SupportedBank) => {
    if (selected === bank.bankChoiceId) {
      handleSubmit?.()
    } else {
      banks?.handleSelectBank(bank)
    }
  }

  return (
    <div className='select-bank-wrapper'>
      {Boolean(loading) && (
        <div className='loading-wrapper'>
          <Spinner />
        </div>
      )}

      {Boolean(banks?.hasBack) && (
        <div className='back-icon' onClick={banks.handleBack} data-test='bank-button'>
          <BackIcon /> {tr('CHECKOUT.BUTTONS.BACK', 'Back')}
        </div>
      )}

      {isValidArray(banks?.banks) ? (
        <div className='bank-selection'>
          {banks.banks.map(bank => {
            return (
              <SelectBankItem
                key={bank.bankChoiceId}
                bank={bank}
                selected={selected === bank.bankChoiceId}
                onClick={() => handleClick(bank)}
                data-test={`bank-${bank.bankChoiceId}`}
              />
            )
          })}
        </div>
      ) : !banks?.treeMode ? (
        <div className='error-text'>
          {banks?.bankSearchText?.length > 2
            ? tr('CHECKOUT.PAYMENT.NO_BANKS_FOUND', 'No banks found')
            : tr('CHECKOUT.PAYMENT.SEARCH_BANK_HINT', 'Type 3 or more characters to filter banks…')}
        </div>
      ) : null}
    </div>
  )
}

export default SelectBank
